<div class="card userProfileAuditTrialList">
	<div class="flex flex-column card-container">
		<div>
			<app-panel-list class="panelListPlaceHolder" [panelList]="userProfileAuditSummaryInput"
				(panelCardClickEvent)="showAuditAttributeDetails($event)" *ngIf="isSummaryLoaded">
				<ng-template #templateRef let-data="dataVar">
					<div panel-content class="grid">
						<div class="col-fixed text-left" style="width: 30%">
							<div class="font-semibold">User</div>
							<div class="mt-1">
								{{ data?.user ? data?.user : 'Automated Process' }}
							</div>
						</div>
						<div class="col-fixed text-left" style="width: 15%">
							<div class="font-semibold">Action</div>
							<div class="mt-1">
								{{ data?.action }}
							</div>
						</div>
						<div class="col-fixed text-left" style="width: 35%">
							<div class="font-semibold">Entity/Attributes</div>
							<div class="mt-1">
								<ul>
									<li class="attribute-name-label" *ngFor="
											let val of data?.attributes | slice : 0 : 3;
											let i = index
										" tooltipPosition="top" pTooltip="{{ val }}">
										{{ val }}
									</li>
									<li *ngIf="data?.attributes.length > 3" class="font-semibold">
										(+{{ data?.attributes.length - 3 }})
									</li>
								</ul>
							</div>
						</div>
						<div class="col-fixed text-left" style="width: 20%">
							<div class="font-semibold">Date</div>
							<div class="mt-1">
								{{ data?.timestamp | date : "dd-MMM-yyyy" }}
							</div>
						</div>
					</div>
				</ng-template>
			</app-panel-list>
		</div>
	</div>
</div>
